import React, { useState, useEffect } from "react";
import {
  useDispatch,
  useSelector
} from "react-redux";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
} from "reactstrap";
import {
  Table, Thead, Tbody, Tr, Th, Td
} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import CustomPagination from "components/Common/CustomPagination";
import { withTranslation } from "react-i18next";
import formatDate, { formatDateBroker } from "helpers/formatDate";
import ReceiptModal from "pages/Transactions/Forex/ReceiptModal";
import { fetchCashbackStart } from "store/transactions/cashback/action";
import TableLoader from "components/Common/Loader";
import ClientCashbackAdvancedFilter from "./ClientCashbackAdvancedFilter";

function ClientCashbacks(props) {
  const clientId = props.clientId;
  const [sizePerPage, setSizePerPage] = useState(10);
  const dispatch = useDispatch();
  const { data, loading, paginationResult, totalCashback } = useSelector(state => state.casehbackReducer);
  const totalAmounts = React.useMemo(() => {
    return data.reduce((acc, item) => acc + Number(item.rawData.cashbackAmount), 0);
  }, [data]);

  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState("");

  const columns = [
    {
      text: props.t("Account"),
      dataField: "Account",
      formatter: (val) => {
        const { logins = [] } = val.rawData;
        return `${logins?.[logins.length - 1] || "-"}`;
      }
    },
    {
      text: props.t("Group Path"),
      dataField: "Group Path",
      formatter: (val) => {
        return val?.rawData?.groupPath || "-";
      }
    },
    {
      text: props.t("Total Lots (Daily)"),
      dataField: "totalClosedLots",
      formatter: (val) => {
        return val.rawData.totalClosedLots.toFixed(2);
      }
    },
    {
      text: props.t("Symbol"),
      dataField: "symbol",
      formatter: (val) => {
        return val?.rawData?.symbol || "-";
      }
    },
    {
      text: props.t("Cashback Amount"),
      dataField: "cashbackAmount",
      formatter: (val) => {
        return `${val.rawData.cashbackAmount} USD`;
      }
    },
    {
      text: props.t("Created At"),
      dataField: "createdAt",
      formatter: (val) => formatDateBroker(val.createdAt, "DD/MM/YYYY"),
    },
  ];
  const [selectedValues, setSelectedValues] = useState({
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
  const loadClientCashbackTransactions = (page, limit) => {
    let values = {};
    Object.keys(selectedValues).forEach(key => {
      if (selectedValues[key]) {
        values[key] = selectedValues[key];
      }
    });
    dispatch(fetchCashbackStart({
      clientId,
      page,
      limit,
      ...values
    }));
  };
  useEffect(() => {
    loadClientCashbackTransactions(1, sizePerPage);
  }, [sizePerPage, selectedValues]);
  return (
    <React.Fragment>
      <div className="">
        <div className="container-fluid">
          <Row>
            <Col className="col-12">
              <Card>
                <CardHeader className="d-flex justify-content-between  align-items-center">
                  <CardTitle className="color-primary">
                    {props.t("Cashback list")} ({`${data?.length > 0 ? data.length : "0"}`})
                  </CardTitle>
                  <ClientCashbackAdvancedFilter selectedValues={selectedValues} setSelectedValues={setSelectedValues} />
                </CardHeader>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div
                      className="table-responsive mb-0"
                      data-pattern="priority-columns"
                    >
                      <Table
                        id="tech-companies-1"
                        className="table  table-hover "
                      >
                        <Thead className="text-center table-light" >
                          <Tr>
                            {columns.map((column, index) =>
                              <Th data-priority={index} key={index}><span className="color-primary">{column.text}</span></Th>
                            )}
                          </Tr>
                        </Thead>
                        <Tbody style={{
                          fontSize: "12px",
                          textAlign: "center",
                          textTransform: "capitalize"
                        }}>
                          {loading && <TableLoader colSpan={4} />}
                          {data.map((row, rowIndex) =>
                            <Tr key={rowIndex}>
                              {columns.map((column, index) =>
                                <Td key={`${rowIndex}-${index}`}>
                                  {column.dataField === "checkbox" ? <input type="checkbox" /> : ""}
                                  {column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                                </Td>
                              )}
                            </Tr>
                          )}
                          {data.length === 0 && !loading && (
                            <Tr>
                              <Td colSpan={"100%"} className="fw-bolder text-center" st>
                                <h3 className="fw-bolder text-center">{props.t("No records")}</h3>
                              </Td>
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                      <CustomPagination
                        {...paginationResult}
                        docs={data}
                        setSizePerPage={setSizePerPage}
                        sizePerPage={sizePerPage}
                        onChange={loadClientCashbackTransactions}
                      />
                    </div>
                  </div>
                </CardBody>
                <div>
                  <p className="text-center">
                    {props.t("Total Cashback Amounts")}: {totalCashback} USD
                  </p>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      {selectedContent && (
        <ReceiptModal
          content={selectedContent}
          open={detailsModal}
          onClose={() => setDetailsModal(false)}
        />
      )}
    </React.Fragment>
  );
}

export default (withTranslation()(ClientCashbacks));
